import {supabase, useInsertDecisionMutation, useUpsertParticipantsMutation} from "../app/api.js";
import {Box,Flex,Avatar,HStack,IconButton,Button,Menu,MenuButton,MenuList,MenuItem,
    useDisclosure,useColorModeValue,Stack} from '@chakra-ui/react'
import { HamburgerIcon, CloseIcon, AddIcon } from '@chakra-ui/icons'
import {set_lang, set_session} from "../app/ui_state.js";
import {path} from 'ramda';
import { useDispatch, useSelector } from "react-redux";
import {useNavigate} from 'react-router-dom'
import LanguageSwitcher from "./langSwitcher.js";

const NavLink = (props) => {
  const { children } = props
  return (
    <Box as="a" px={2} py={1} rounded={'md'} _hover={{
        textDecoration: 'none',
        bg: useColorModeValue('gray.200', 'gray.700'),
      }}
      href={props.to}>
      {children}
    </Box>
  )
}

export default function HeadingBar({ buttons }) {
  const session = useSelector(path(["ui","session"]));
  const texts = useSelector(path(["ui","ui_texts"]));
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [insertDecision] = useInsertDecisionMutation();
  const [upsertParticipant] = useUpsertParticipantsMutation();
  const language = useSelector(path(["ui","lang"]));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const addDecision = async () => {
    const decision = await insertDecision({owner_id:session?.user?.id });
    const {data:participate} = await upsertParticipant({
      decision_id:decision.data[0].id, 
      email: session?.user?.email, 
      user_id: session?.user?.id 
    });
    if(participate.length) navigate(`/app/${path(["data",0,"id"],decision)}`)
  }
  return (
    <>
      <Box as="header" position="fixed" top={0} zIndex={10} w="100%" bg={useColorModeValue('gray.100', 'gray.900')} px={4}>
        <Flex h={16} alignItems={'center'} justifyContent={'space-between'}>
            <IconButton size={'md'} icon={isOpen ? <CloseIcon /> : <HamburgerIcon />} 
              aria-label={'Open Menu'} display={{ md: 'none' }} onClick={isOpen ? onClose : onOpen}/>
            <HStack spacing={8} alignItems={'center'}>
              {buttons &&<HStack as={'nav'} spacing={4} display={{ base: 'none', md: 'flex' }}>
                <NavLink key={"decisions"} to={"/app"}>{texts.decisions}</NavLink>
              </HStack>}
            </HStack>
            <Flex alignItems={'center'}>
              <LanguageSwitcher currentLang={language} />
              {buttons && <Button variant={'solid'} colorScheme={'teal'} size={'sm'} mr={4}  onClick={addDecision} leftIcon={<AddIcon />}>
                {texts.add_new}
              </Button>}
              {!buttons && !session?.user ? null : 
                <Menu>
                  <MenuButton as={Button} rounded={'full'} variant={'link'} cursor={'pointer'} minW={0}>
                    <Avatar size={'sm'}/>
                  </MenuButton>
                    <MenuList>
                      <MenuItem as='a' href='/konto'>{texts.account}</MenuItem>
                      <MenuItem onClick={() => {supabase.auth.signOut();dispatch(set_session(undefined))}}>{texts.log_out}</MenuItem>
                    </MenuList>
                </Menu>
              }
            </Flex>   
          </Flex>

          {isOpen ? (
            <Box pb={4} display={{ md: 'none' }}>
              <Stack as={'nav'} spacing={4}>
                <NavLink key={"decisions"} to={"/app"}>{texts.decisions}</NavLink>
              </Stack>
            </Box>
          ) : null}
      </Box>
    </>
  )
}